<template lang="pug">
.options
	.backdrop
	.content
		.loading

</template>

<script>
import Button from '@/components/Button.vue';

export default {
  components: {
    Button,
  },
  props: ['overlaydata'],
  methods: {
    cancel() {
      this.$store.commit('openOverlay', '');
    },
    showInfo(message, title) {
      this.$store.commit('openOverlay', {
        overlayName: 'Info',
        overlayData: {
          title,
          message,
        },
      });
    },
  },
};
</script>

<style lang="sass" scoped>
.options
  width: 100%
  height: 100vh
  display: flex
  flex-direction: column
  align-items: center
  justify-content: center
  position: fixed
  max-width: 480px
  margin: 0 auto
  right: 0
  top: 0
  left: 0
  z-index: 9

.backdrop
  background-color: rgba(0, 0, 0, .8)
  width: 100%
  height: 100vh
  position: absolute
  z-index: 6

.content
  display: flex
  align-items: center
  justify-content: center
  z-index: 7

.loading
  width: 100px
  height: 100px
  border-radius: 100%
  border: 10px solid transparent
  border-bottom-color: #fff
  border-top-color: #fff
  animation: rotate 1s infinite

@keyframes rotate
  from
    transform: rotate(0deg)
  to
    transform: rotate(360deg)
</style>
